module.exports = __webpack_public_path__ + "static/media/awschd32_400.b554fba1.ico";